import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GenericFilter } from '../models/GenericFilter';
import { NgxFormlyFormDto, NgxFormlyFormsDto } from '../models/NgxFormlyFormDto';
import { ValueConfAttributeDto, ValueConfAttributesDto } from '../models/ValueConfAttribute';
import { BaseService } from './base.service';
import { OAuthServiceService } from './o-auth-service.service';

@Injectable({ providedIn: 'root' })
export class ValueConfAttributeService extends BaseService {
  
  constructor(private httpClient: HttpClient,
    private oauthService: OAuthServiceService) {
    super();
  }

  getValueConfAttribute(id: string, dbname: string): Observable<ValueConfAttributeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<ValueConfAttributeDto>(`${this.valueConfAttribute}/${id}`, { headers: headers });
  }

  getValueConfAttributes(pageId: string, dbname: string): Observable<ValueConfAttributeDto[]> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<ValueConfAttributeDto[]>(`${this.valueConfAttribute}/${pageId}/ValueConfAttributes`, { headers: headers });
  }

  getNgxFormlyForms(pageId: string, dbname: string): Observable<NgxFormlyFormDto[]> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<NgxFormlyFormDto[]>(`${this.valueConfAttribute}/${pageId}/NgxFormlyForms`, { headers: headers });
  }


  loadValueConfAttributes(searchText: string, page: number, pageSize: number, dbname: string): Observable<ValueConfAttributesDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<ValueConfAttributesDto>(`${this.valueConfAttribute}?searchText=${searchText}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  createValueConfAttribute(valueConfAttributeDto: ValueConfAttributeDto, dbname: string): Observable<ValueConfAttributeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<ValueConfAttributeDto>(`${this.valueConfAttribute}`, valueConfAttributeDto, { headers: headers });
  }

  loadNgxFormlyForm(searchText: string, page: number, pageSize: number, dbname: string): Observable<NgxFormlyFormsDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.get<NgxFormlyFormsDto>(`${this.valueConfAttribute}/GetNgxFormlyForms?searchText=${searchText}&page=${page}&pageSize=${pageSize}`, { headers: headers });
  }

  loadNgxFormlyForms(dbname: any, genericFilter: GenericFilter) : Observable<NgxFormlyFormDto[]>{
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<NgxFormlyFormDto[]>(`${this.valueConfAttribute}/GetFilteredNgxFormlyForms`, genericFilter, { headers: headers });
  }

  createNgxFormlyFormAttribute(ngxFormlyFormDto: NgxFormlyFormDto, dbname: string): Observable<NgxFormlyFormDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.post<NgxFormlyFormDto>(`${this.valueConfAttribute}`, ngxFormlyFormDto, { headers: headers });
  }

  updateValueConfAttribute(valueConfAttributeDto: ValueConfAttributeDto, dbname: string): Observable<ValueConfAttributeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.put<ValueConfAttributeDto>(`${this.valueConfAttribute}/${valueConfAttributeDto.id}`, valueConfAttributeDto, { headers: headers });
  }

  deleteValueConfAttribute(valueConfAttributeDto: ValueConfAttributeDto, dbname: string): Observable<ValueConfAttributeDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<ValueConfAttributeDto>(`${this.valueConfAttribute}/${valueConfAttributeDto.id}`, { headers: headers });
  }

  deleteNgxFormlyFormAttribute(ngxFormlyFormDto: NgxFormlyFormDto, dbname: any): Observable<NgxFormlyFormDto> {
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${this.oauthService.token}`)
      .set('dbname', dbname);
    return this.httpClient.delete<NgxFormlyFormDto>(`${this.valueConfAttribute}/${ngxFormlyFormDto.id}/NgxFormlyForm?pageId=${ngxFormlyFormDto.pageId}`, { headers: headers });
  }
}
